import React from "react";

import "../../i18n/i18n";
import { useTranslation } from "react-i18next";

const TextError = (props: any) => {
    const { t } = useTranslation();

    let erorrMsg;
    if(props.children === "This field is required"){
        erorrMsg = t("This field is required");
    }else{
        erorrMsg = props.children;
    }

    return (
        <>
            {!Array.isArray(props.children) ?
                <div className="error-message mb-1">
                    {erorrMsg}
                </div>
                :
                ""
            }
        </>

    );
};

export default TextError;